export enum Season {
  id = 'Crypto 2021',
}
